"use strict";

var _regeneratorRuntime = require("/Users/jonthornton/Sites/ministry-of-eco-education-website/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/Users/jonthornton/Sites/ministry-of-eco-education-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _classCallCheck = require("/Users/jonthornton/Sites/ministry-of-eco-education-website/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/Users/jonthornton/Sites/ministry-of-eco-education-website/node_modules/@babel/runtime/helpers/createClass.js");
var _a, _IsomorphicClerk_loaded, _IsomorphicClerk_instance;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var tslib_1 = require("tslib");
var errors_1 = require("./errors");
var utils_1 = require("./utils");
var IsomorphicClerk = /*#__PURE__*/function () {
  function IsomorphicClerk(params) {
    var _this = this;
    _classCallCheck(this, IsomorphicClerk);
    this.clerkjs = null;
    this.preopenSignIn = null;
    this.preopenSignUp = null;
    this.preopenUserProfile = null;
    this.preopenOrganizationProfile = null;
    this.premountSignInNodes = new Map();
    this.premountSignUpNodes = new Map();
    this.premountUserProfileNodes = new Map();
    this.premountUserButtonNodes = new Map();
    this.premountOrganizationProfileNodes = new Map();
    this.premountCreateOrganizationNodes = new Map();
    this.premountOrganizationSwitcherNodes = new Map();
    this.premountMethodCalls = new Map();
    this.loadedListeners = [];
    _IsomorphicClerk_loaded.set(this, false);
    this.addOnLoaded = function (cb) {
      _this.loadedListeners.push(cb);
    };
    this.emitLoaded = function () {
      _this.loadedListeners.forEach(function (cb) {
        return cb();
      });
      _this.loadedListeners = [];
    };
    this.hydrateClerkJS = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(clerkjs) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (clerkjs) {
                  _context.next = 2;
                  break;
                }
                throw new Error('Failed to hydrate latest Clerk JS');
              case 2:
                _this.clerkjs = clerkjs;
                _this.premountMethodCalls.forEach(function (cb) {
                  return cb();
                });
                if (_this.preopenSignIn !== null) {
                  clerkjs.openSignIn(_this.preopenSignIn);
                }
                if (_this.preopenSignUp !== null) {
                  clerkjs.openSignUp(_this.preopenSignUp);
                }
                if (_this.preopenUserProfile !== null) {
                  clerkjs.openUserProfile(_this.preopenUserProfile);
                }
                _this.premountSignInNodes.forEach(function (props, node) {
                  clerkjs.mountSignIn(node, props);
                });
                _this.premountSignUpNodes.forEach(function (props, node) {
                  clerkjs.mountSignUp(node, props);
                });
                _this.premountUserProfileNodes.forEach(function (props, node) {
                  clerkjs.mountUserProfile(node, props);
                });
                _this.premountUserButtonNodes.forEach(function (props, node) {
                  clerkjs.mountUserButton(node, props);
                });
                tslib_1.__classPrivateFieldSet(_this, _IsomorphicClerk_loaded, true, "f");
                _this.emitLoaded();
                return _context.abrupt("return", _this.clerkjs);
              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    this.__unstable__updateProps = function (props) {
      // Handle case where accounts has clerk-react@4 installed, but clerk-js@3 is manually loaded
      if (_this.clerkjs && '__unstable__updateProps' in _this.clerkjs) {
        _this.clerkjs.__unstable__updateProps(props);
      } else {
        return undefined;
      }
    };
    /**
     * `setActive` can be used to set the active session and/or organization.
     * It will eventually replace `setSession`.
     *
     * @experimental
     */
    this.setActive = function (_ref2) {
      var session = _ref2.session,
        organization = _ref2.organization,
        beforeEmit = _ref2.beforeEmit;
      if (_this.clerkjs) {
        return _this.clerkjs.setActive({
          session: session,
          organization: organization,
          beforeEmit: beforeEmit
        });
      } else {
        return Promise.reject();
      }
    };
    this.setSession = function (session, beforeEmit) {
      return _this.setActive({
        session: session,
        beforeEmit: beforeEmit
      });
    };
    this.openSignIn = function (props) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.openSignIn(props);
      } else {
        _this.preopenSignIn = props;
      }
    };
    this.closeSignIn = function () {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.closeSignIn();
      } else {
        _this.preopenSignIn = null;
      }
    };
    this.openUserProfile = function (props) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.openUserProfile(props);
      } else {
        _this.preopenUserProfile = props;
      }
    };
    this.closeUserProfile = function () {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.closeUserProfile();
      } else {
        _this.preopenUserProfile = null;
      }
    };
    this.openOrganizationProfile = function (props) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.openOrganizationProfile(props);
      } else {
        _this.preopenOrganizationProfile = props;
      }
    };
    this.closeOrganizationProfile = function () {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.closeOrganizationProfile();
      } else {
        _this.preopenOrganizationProfile = null;
      }
    };
    this.openSignUp = function (props) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.openSignUp(props);
      } else {
        _this.preopenSignUp = props;
      }
    };
    this.closeSignUp = function () {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.closeSignUp();
      } else {
        _this.preopenSignUp = null;
      }
    };
    this.mountSignIn = function (node, props) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.mountSignIn(node, props);
      } else {
        _this.premountSignInNodes.set(node, props);
      }
    };
    this.unmountSignIn = function (node) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.unmountSignIn(node);
      } else {
        _this.premountSignInNodes.delete(node);
      }
    };
    this.mountSignUp = function (node, props) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.mountSignUp(node, props);
      } else {
        _this.premountSignUpNodes.set(node, props);
      }
    };
    this.unmountSignUp = function (node) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.unmountSignUp(node);
      } else {
        _this.premountSignUpNodes.delete(node);
      }
    };
    this.mountUserProfile = function (node, props) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.mountUserProfile(node, props);
      } else {
        _this.premountUserProfileNodes.set(node, props);
      }
    };
    this.unmountUserProfile = function (node) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.unmountUserProfile(node);
      } else {
        _this.premountUserProfileNodes.delete(node);
      }
    };
    this.mountOrganizationProfile = function (node, props) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.mountOrganizationProfile(node, props);
      } else {
        _this.premountOrganizationProfileNodes.set(node, props);
      }
    };
    this.unmountOrganizationProfile = function (node) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.unmountOrganizationProfile(node);
      } else {
        _this.premountOrganizationProfileNodes.delete(node);
      }
    };
    this.mountCreateOrganization = function (node, props) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.mountCreateOrganization(node, props);
      } else {
        _this.premountCreateOrganizationNodes.set(node, props);
      }
    };
    this.unmountCreateOrganization = function (node) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.unmountCreateOrganization(node);
      } else {
        _this.premountCreateOrganizationNodes.delete(node);
      }
    };
    this.mountOrganizationSwitcher = function (node, props) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.mountOrganizationSwitcher(node, props);
      } else {
        _this.premountOrganizationSwitcherNodes.set(node, props);
      }
    };
    this.unmountOrganizationSwitcher = function (node) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.unmountOrganizationSwitcher(node);
      } else {
        _this.premountOrganizationSwitcherNodes.delete(node);
      }
    };
    this.mountUserButton = function (node, userButtonProps) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.mountUserButton(node, userButtonProps);
      } else {
        _this.premountUserButtonNodes.set(node, userButtonProps);
      }
    };
    this.unmountUserButton = function (node) {
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        _this.clerkjs.unmountUserButton(node);
      } else {
        _this.premountUserButtonNodes.delete(node);
      }
    };
    this.addListener = function (listener) {
      var callback = function callback() {
        var _b;
        return (_b = _this.clerkjs) === null || _b === void 0 ? void 0 : _b.addListener(listener);
      };
      if (_this.clerkjs) {
        callback();
      } else {
        _this.premountMethodCalls.set('addListener', callback);
      }
    };
    this.navigate = function (to) {
      var callback = function callback() {
        var _b;
        return (_b = _this.clerkjs) === null || _b === void 0 ? void 0 : _b.navigate(to);
      };
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        void callback();
      } else {
        _this.premountMethodCalls.set('navigate', callback);
      }
    };
    this.redirectToSignIn = function (opts) {
      var callback = function callback() {
        var _b;
        return (_b = _this.clerkjs) === null || _b === void 0 ? void 0 : _b.redirectToSignIn(opts);
      };
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        void callback();
      } else {
        _this.premountMethodCalls.set('redirectToSignIn', callback);
      }
    };
    this.redirectToSignUp = function (opts) {
      var callback = function callback() {
        var _b;
        return (_b = _this.clerkjs) === null || _b === void 0 ? void 0 : _b.redirectToSignUp(opts);
      };
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        void callback();
      } else {
        _this.premountMethodCalls.set('redirectToSignUp', callback);
      }
    };
    this.redirectToUserProfile = function () {
      var callback = function callback() {
        var _b;
        return (_b = _this.clerkjs) === null || _b === void 0 ? void 0 : _b.redirectToUserProfile();
      };
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        callback();
      } else {
        _this.premountMethodCalls.set('redirectToUserProfile', callback);
      }
    };
    this.redirectToHome = function () {
      var callback = function callback() {
        var _b;
        return (_b = _this.clerkjs) === null || _b === void 0 ? void 0 : _b.redirectToHome();
      };
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        callback();
      } else {
        _this.premountMethodCalls.set('redirectToHome', callback);
      }
    };
    this.redirectToOrganizationProfile = function () {
      var callback = function callback() {
        var _b;
        return (_b = _this.clerkjs) === null || _b === void 0 ? void 0 : _b.redirectToOrganizationProfile();
      };
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        callback();
      } else {
        _this.premountMethodCalls.set('redirectToOrganizationProfile', callback);
      }
    };
    this.redirectToCreateOrganization = function () {
      var callback = function callback() {
        var _b;
        return (_b = _this.clerkjs) === null || _b === void 0 ? void 0 : _b.redirectToCreateOrganization();
      };
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        callback();
      } else {
        _this.premountMethodCalls.set('redirectToCreateOrganization', callback);
      }
    };
    this.handleRedirectCallback = function (params) {
      var callback = function callback() {
        var _b;
        return (_b = _this.clerkjs) === null || _b === void 0 ? void 0 : _b.handleRedirectCallback(params);
      };
      if (_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f")) {
        void callback();
      } else {
        _this.premountMethodCalls.set('handleRedirectCallback', callback);
      }
    };
    this.handleMagicLinkVerification = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        var callback;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                callback = function callback() {
                  var _b;
                  return (_b = _this.clerkjs) === null || _b === void 0 ? void 0 : _b.handleMagicLinkVerification(params);
                };
                if (!(_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f"))) {
                  _context2.next = 5;
                  break;
                }
                return _context2.abrupt("return", callback());
              case 5:
                _this.premountMethodCalls.set('handleMagicLinkVerification', callback);
              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
    this.authenticateWithMetamask = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
        var callback;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                callback = function callback() {
                  var _b;
                  return (_b = _this.clerkjs) === null || _b === void 0 ? void 0 : _b.authenticateWithMetamask(params);
                };
                if (!(_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f"))) {
                  _context3.next = 5;
                  break;
                }
                return _context3.abrupt("return", callback());
              case 5:
                _this.premountMethodCalls.set('authenticateWithMetamask', callback);
              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }();
    this.createOrganization = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
        var callback;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                callback = function callback() {
                  var _b;
                  return (_b = _this.clerkjs) === null || _b === void 0 ? void 0 : _b.createOrganization(params);
                };
                if (!(_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f"))) {
                  _context4.next = 5;
                  break;
                }
                return _context4.abrupt("return", callback());
              case 5:
                _this.premountMethodCalls.set('createOrganization', callback);
              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return function (_x4) {
        return _ref5.apply(this, arguments);
      };
    }();
    this.getOrganizationMemberships = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var callback;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              callback = function callback() {
                var _b;
                return (_b = _this.clerkjs) === null || _b === void 0 ? void 0 : _b.getOrganizationMemberships();
              };
              if (!(_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f"))) {
                _context5.next = 5;
                break;
              }
              return _context5.abrupt("return", callback());
            case 5:
              _this.premountMethodCalls.set('getOrganizationMemberships', callback);
            case 6:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    this.getOrganization = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(organizationId) {
        var callback;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                callback = function callback() {
                  var _b;
                  return (_b = _this.clerkjs) === null || _b === void 0 ? void 0 : _b.getOrganization(organizationId);
                };
                if (!(_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f"))) {
                  _context6.next = 5;
                  break;
                }
                return _context6.abrupt("return", callback());
              case 5:
                _this.premountMethodCalls.set('getOrganization', callback);
              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return function (_x5) {
        return _ref7.apply(this, arguments);
      };
    }();
    this.signOut = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(signOutCallbackOrOptions, options) {
        var callback;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                callback = function callback() {
                  var _b;
                  return (_b = _this.clerkjs) === null || _b === void 0 ? void 0 : _b.signOut(signOutCallbackOrOptions, options);
                };
                if (!(_this.clerkjs && tslib_1.__classPrivateFieldGet(_this, _IsomorphicClerk_loaded, "f"))) {
                  _context7.next = 5;
                  break;
                }
                return _context7.abrupt("return", callback());
              case 5:
                _this.premountMethodCalls.set('signOut', callback);
              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
      return function (_x6, _x7) {
        return _ref8.apply(this, arguments);
      };
    }();
    var _ref9 = params || {},
      _ref9$Clerk = _ref9.Clerk,
      Clerk = _ref9$Clerk === void 0 ? null : _ref9$Clerk,
      frontendApi = _ref9.frontendApi,
      _ref9$options = _ref9.options,
      options = _ref9$options === void 0 ? {} : _ref9$options;
    this.frontendApi = frontendApi;
    this.options = options;
    this.Clerk = Clerk;
    this.mode = (0, utils_1.inClientSide)() ? 'browser' : 'server';
    void this.loadClerkJS();
  }
  _createClass(IsomorphicClerk, [{
    key: "loaded",
    get: function get() {
      return tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f");
    }
  }, {
    key: "loadClerkJS",
    value: function () {
      var _loadClerkJS = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var c, message;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(this.mode !== 'browser' || tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f"))) {
                  _context8.next = 2;
                  break;
                }
                return _context8.abrupt("return");
              case 2:
                if (!this.frontendApi) {
                  this.throwError(errors_1.noFrontendApiError);
                }
                // Store frontendAPI value on window as a fallback. This value can be used as a
                // fallback during ClerkJS hot loading in case ClerkJS fails to find the
                // "data-clerk-frontend-api" attribute on its script tag.
                // This can happen when the DOM is altered completely during client rehydration.
                // For example, in Remix with React 18 the document changes completely via `hydrateRoot(document)`.
                // For more information refer to:
                // - https://github.com/remix-run/remix/issues/2947
                // - https://github.com/facebook/react/issues/24430
                window.__clerk_frontend_api = this.frontendApi;
                _context8.prev = 4;
                if (!this.Clerk) {
                  _context8.next = 19;
                  break;
                }
                if (!(0, utils_1.isConstructor)(this.Clerk)) {
                  _context8.next = 12;
                  break;
                }
                // Construct a new Clerk object if a constructor is passed
                c = new this.Clerk(this.frontendApi);
                _context8.next = 10;
                return c.load(this.options);
              case 10:
                _context8.next = 16;
                break;
              case 12:
                // Otherwise use the instantiated Clerk object
                c = this.Clerk;
                if (c.isReady()) {
                  _context8.next = 16;
                  break;
                }
                _context8.next = 16;
                return c.load(this.options);
              case 16:
                global.Clerk = c;
                _context8.next = 25;
                break;
              case 19:
                _context8.next = 21;
                return (0, utils_1.loadScript)({
                  frontendApi: this.frontendApi,
                  scriptUrl: this.options.clerkJSUrl,
                  scriptVariant: this.options.clerkJSVariant
                });
              case 21:
                if (global.Clerk) {
                  _context8.next = 23;
                  break;
                }
                throw new Error('Failed to download latest ClerkJS. Contact support@clerk.dev.');
              case 23:
                _context8.next = 25;
                return global.Clerk.load(this.options);
              case 25:
                return _context8.abrupt("return", this.hydrateClerkJS(global.Clerk));
              case 28:
                _context8.prev = 28;
                _context8.t0 = _context8["catch"](4);
                if (_context8.t0 instanceof Error) {
                  message = _context8.t0.message;
                } else {
                  message = String(_context8.t0);
                }
                this.throwError(message);
                return _context8.abrupt("return");
              case 33:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[4, 28]]);
      }));
      function loadClerkJS() {
        return _loadClerkJS.apply(this, arguments);
      }
      return loadClerkJS;
    }() // Custom wrapper to throw an error, since we need to apply different handling between
    // production and development builds. In Next.js we can throw a full screen error in
    // development mode. However, in production throwing an error results in an infinite loop
    // as shown at https://github.com/vercel/next.js/issues/6973
  }, {
    key: "throwError",
    value: function throwError(errorMsg) {
      if (process.env.NODE_ENV === 'production') {
        console.error(errorMsg);
      }
      throw new Error(errorMsg);
    }
  }, {
    key: "version",
    get: function get() {
      var _b;
      return (_b = this.clerkjs) === null || _b === void 0 ? void 0 : _b.version;
    }
  }, {
    key: "client",
    get: function get() {
      if (this.clerkjs) {
        return this.clerkjs.client;
        // TODO: add ssr condition
      } else {
        return undefined;
      }
    }
  }, {
    key: "session",
    get: function get() {
      if (this.clerkjs) {
        return this.clerkjs.session;
        // TODO: add ssr condition
      } else {
        return undefined;
      }
    }
  }, {
    key: "user",
    get: function get() {
      if (this.clerkjs) {
        return this.clerkjs.user;
      } else {
        return undefined;
      }
    }
  }, {
    key: "organization",
    get: function get() {
      if (this.clerkjs) {
        return this.clerkjs.organization;
      } else {
        return undefined;
      }
    }
  }, {
    key: "__unstable__environment",
    get: function get() {
      if (this.clerkjs) {
        return this.clerkjs.__unstable__environment;
        // TODO: add ssr condition
      } else {
        return undefined;
      }
    }
  }, {
    key: "__unstable__setEnvironment",
    value: function __unstable__setEnvironment() {
      if (this.clerkjs && '__unstable__setEnvironment' in this.clerkjs) {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        this.clerkjs.__unstable__setEnvironment(args);
      } else {
        return undefined;
      }
    }
  }], [{
    key: "getOrCreateInstance",
    value: function getOrCreateInstance(params) {
      // During SSR: a new instance should be created for every request
      // During CSR: use the cached instance for the whole lifetime of the app
      // This method should be idempotent in both scenarios
      if (!(0, utils_1.inClientSide)() || !tslib_1.__classPrivateFieldGet(this, _a, "f", _IsomorphicClerk_instance)) {
        tslib_1.__classPrivateFieldSet(this, _a, new IsomorphicClerk(params), "f", _IsomorphicClerk_instance);
      }
      return tslib_1.__classPrivateFieldGet(this, _a, "f", _IsomorphicClerk_instance);
    }
  }]);
  return IsomorphicClerk;
}();
exports.default = IsomorphicClerk;
_a = IsomorphicClerk, _IsomorphicClerk_loaded = new WeakMap();
_IsomorphicClerk_instance = {
  value: void 0
};